import React, { useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { toast } from "react-toastify";
import { forgotPasswordHandler } from "../../../service/AuthService";

const ForgotPasswordForm = ({ onFormChange }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleForgotPassword = async () => {
    setIsLoading(true);
    try {
      localStorage.setItem("forgotPasswordEmail", email);
      await forgotPasswordHandler({ email });
      onFormChange("otp"); 
      toast.success("Please check your email for verification code");
    } catch (error) {
      setError(error.message || "Something went wrong");
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackLogin = () => {
    onFormChange("login");
  };

  return (
    <>
      <div className="my-auto mx-auto flex flex-col justify-center px-6 pt-8 md:justify-start lg:w-[28rem]">
        <p className="text-center text-3xl font-bold md:text-left md:leading-tight">
          Password recovery
        </p>
        <p className="mt-2 text-center text-gray-500 font-medium md:text-left">
          Enter your email and we'll email you an OTP verification code.
        </p>
        <div className="flex flex-col items-stretch pt-3 md:pt-8">
          <div className="flex flex-col pt-6">
            <div className="relative flex overflow-hidden rounded-md ">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={handleInputChange}
                className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border-2 border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
              />
              {error && (
                <div className="text-red-500 text-xs mt-1 m1-2">{error}</div>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between">
            <IoMdArrowRoundBack
              className="mt-6 text-2xl text-gray-400 cursor-pointer"
              onClick={handleBackLogin}
            />
            <button
              onClick={handleForgotPassword}
              disabled={isLoading}
              className="mt-6 rounded-lg bg-gray-800 px-4 py-2 text-center text-base font-semibold text-white shadow-md outline-none ring-gray-500 ring-offset-2 transition hover:bg-gray-900 focus:ring-2 md:w-32"
            >
              {isLoading ? "Sending..." : "Get OTP"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordForm;
